import {
  createFileRoute,
  Outlet,
  redirect,
  useParams,
} from "@tanstack/react-router";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { LangProvider } from "../contexts/LangContext";

const allowedLanguages = ["oz", "uz", "ru", "en"];

export const Route = createFileRoute("/$lang")({
  beforeLoad: ({ params }) => {
    if (!allowedLanguages.includes(params.lang)) {
      throw redirect({ to: "/" });
    }
    if (params.lang === "oz") {
      throw redirect({ to: "/" });
    }
  },
  component: LangLayout,
});

function LangLayout() {
  const { lang } = useParams({ from: "/$lang" });
  const { i18n } = useTranslation();

  useEffect(() => {
    const langMap: Record<string, string> = {
      oz: "uz-Latn", // Uzbek Latin (default)
      uz: "uz-Cyrl", // Uzbek Cyrillic
      ru: "ru", // Russian
      en: "en", // English (matches the hreflang code)
    };
    document.documentElement.lang = langMap[lang] || "uz-Latn";
    // Guard for SSR: only call changeLanguage if it exists
    if (i18n?.changeLanguage) {
      i18n.changeLanguage(lang);
    }
  }, [lang, i18n]);

  const langMapForContext: Record<string, string> = {
    oz: "uz-Latn",
    uz: "uz-Cyrl",
    ru: "ru",
    en: "en-US",
  };

  return (
    <LangProvider lang={langMapForContext[lang] || "uz-Latn"}>
      <Outlet />
    </LangProvider>
  );
}
